import React, { Component } from 'react';
import { connect } from 'react-redux';
import OpcoesPaginacao from '../../comum/OpcoesPaginacao';
import alterarRegistrosPorPagina from '../../../actions/resumo-financeiro/alterarRegistrosPorPaginaResumoFinanceiro';
import determinarPaginaAtual from '../../../actions/resumo-financeiro/determinarPaginaAtualResumoFinanceiro';

export class OpcoesPaginacaoResumoFinanceiro extends Component {
  render () {
    if (this.props.resumoFinanceiro.length === 0) {
      return '';
    }

    return <OpcoesPaginacao
      registrosPorPagina={this.props.registrosPorPagina}
      numeroElementos={this.props.resumoFinanceiro.length}
      paginaAtual={this.props.paginaAtual}
      determinarPaginaAtual={this.props.determinarPaginaAtual}
      alterarRegistrosPorPagina={this.props.alterarRegistrosPorPagina}/>;
  }
}

export function mapStateToProps (state) {
  return {
    resumoFinanceiro: state.resumoFinanceiro.resumos,
    paginaAtual: state.paginaAtualResumoFinanceiro,
    registrosPorPagina: state.registrosPorPaginaResumoFinanceiro
  };
}

export default connect(mapStateToProps, {
  alterarRegistrosPorPagina,
  determinarPaginaAtual
})(OpcoesPaginacaoResumoFinanceiro);
